exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-white{background-color:#fff}.clear:after{content:\"\";display:table;clear:both}.overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.7);transition:opacity .5s;visibility:hidden;opacity:0;overflow-y:scroll}.overlay:target{visibility:visible;transition:opacity .5s;opacity:1;z-index:1000}.overlay .close{position:absolute;top:-40px;right:0;font-size:30px;font-weight:700;text-decoration:none;color:#fff}.overlay .close:hover{color:#00448a}.overlay>*{position:relative;margin:40px auto;padding:20px 15px 5px;background:#fff;width:70%;border:4px solid #00448a;text-align:left;max-width:450px}.overlay h2,.overlay h3{margin-top:0}.overlay h3{margin-bottom:5px}.overlay span{display:block}.overlay a{text-decoration:underline;color:#00ab9d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6141a605","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?data=@import "./src/scss/variables";@import "./src/scss/mixins";@import "./src/scss/helper";!./src/components/overlays/style.scss
// module id = 201
// module chunks = 0